import React from "react";

import NewUserDialog from "./NewUserDialog";
import type FetchStatus from "../../store/FetchStatus";
import {userService} from "../../store/services/userService";

function NewOrganisationUserDialog(props: {
	titleElementId: string;
	organisationName: string;
	onCancel: () => void;

	dialogRef?: React.Ref<{status: () => FetchStatus}>;
}) {
	return (
		<NewUserDialog
			onCancel={props.onCancel}
			titleElementId={props.titleElementId}
			dialogRef={props.dialogRef}
			onCreate={(u) => userService.createUser(props.organisationName, u)}
			createLinks={(id) => ({
				profile: `users/${id}`,
				roles: `users/${id}/roles`,
			})}
		/>
	);
}

export default NewOrganisationUserDialog;
